import '.av{flex-shrink:0;}.ssr-plugin'
import '.a2{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ay{height:100%;}.ssr-plugin'
import '.cd{border:none;}.ssr-plugin'
import '.gp{background-color:transparent;}.ssr-plugin'
import '.gq{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.bg{position:sticky;}.ssr-plugin'
import '.gr{top:4rem;}.ssr-plugin'
import '.gs{z-index:7;}.ssr-plugin'
import '.ad{background-color:var(--palette-white);}.ssr-plugin'
import '.gt{padding-bottom:1rem;}.ssr-plugin'
import '.ck{margin-bottom:1rem;}.ssr-plugin'
import '.gu{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.bh{top:0px;}.ssr-plugin'
import '.bm{left:0px;}.ssr-plugin'
import '.bn{right:0px;}.ssr-plugin'
import '.bo{bottom:0px;}.ssr-plugin'
import '.d4{z-index:9999;}.ssr-plugin'
import '.d5{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.be{justify-content:flex-end;}.ssr-plugin'
import '.az{flex:1;}.ssr-plugin'
import '.bx{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="av a2 n ay cd gp gq"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e ab"
    >
      <div className="bg gr gs ad gt ck gu d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i bh bm bn bo d4 ad d5 d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="a2 d be gu"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="az bx">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
